import React from 'react';
import { Box, Card, CardContent, CardHeader, Typography } from '@mui/material';
import { Title } from 'react-admin';
import BusinessInsightsImage from '../../extensions/neo/insights/Insights-Business.png';

/**
 * Cost Optimizations Placeholder Page
 * 
 * This component will display cost optimization recommendations
 * and savings opportunities.
 */
export const CostOptimizations = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Title title="Cost Optimizations" />
      
      <Card>
        <CardHeader 
          title="Cost Optimizations" 
          subheader="Coming Soon - Cost Reduction Opportunities"
        />
        <CardContent>
          <Typography variant="body1" gutterBottom>
            This page will provide actionable cost optimization recommendations, including:
          </Typography>
          
          <Box sx={{ marginTop: 2, marginLeft: 2 }}>
            <Typography variant="body2" component="ul">
              <li>Alternative supplier suggestions with cost comparisons</li>
              <li>Bulk purchasing opportunities</li>
              <li>Menu item profitability analysis</li>
              <li>Ingredient substitution recommendations</li>
              <li>Waste reduction strategies</li>
              <li>Seasonal purchasing recommendations</li>
              <li>Contract renegotiation opportunities</li>
            </Typography>
          </Box>
          
          <Box 
            sx={{ 
              marginTop: 3,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#f5f5f5',
              padding: 2,
              borderRadius: 1,
              overflow: 'auto'
            }}
          >
            <img 
              src={BusinessInsightsImage} 
              alt="Business Insights Design Mockup" 
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }} 
            />
          </Box>
          
          <Typography 
            variant="caption" 
            display="block" 
            sx={{ marginTop: 2, textAlign: 'center', color: 'text.secondary' }}
          >
            Design mockup for the upcoming Cost Optimization interface
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CostOptimizations;

